// extracted by mini-css-extract-plugin
export default {"title":"Success_title__S3E8g","body":"Success_body__lMofx"};